import { styled } from '@mui/material'
import { TableCell as BaseTableCell, TableRow as BaseTableRow } from '@chilecompra/react-kit/components'

export const Box = styled('div')`
  align-items: center;
  display: flex;
  flex-flow: column;
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin || '0'};
  width: ${props => props.width};

  ${props => props.theme.breakpoints.up('sm')} {
    flex-flow: row;
  }
`

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 16px;
  width: 100%;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`

export const TableRow = styled(BaseTableRow)`
  background-color: ${props => props.theme.palette.custom.blue[95.5]};
`
